module.exports = __webpack_public_path__ + "static/media/ben-3.71536a08.svg";